<template>
  <div>
    <DiseaseImageComponent :properties="component.disease">
    </DiseaseImageComponent>
    <CRow>
      <CCol md="6" lg="6" xxl="4">
        <CCard>
          <CCardHeader>
            <circle-icon></circle-icon>
            지역별 발생수
          </CCardHeader>
          <CCardBody class="p-1">
            <DiseaseAreaCountMapComponent
              :properties="component.area"
              style="min-height: 334px"
            >
            </DiseaseAreaCountMapComponent>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md="6" lg="6" xxl="8">
        <CCard>
          <CCardHeader>
            <circle-icon></circle-icon>
            {{ areaText }} 분석 이미지
          </CCardHeader>
          <CCardBody>
            <DiseaseAreaGalleryComponent
              :properties="component.gallery"
              style="height: 300px"
            >
            </DiseaseAreaGalleryComponent>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import DiseaseImageComponent from "@/components/analysis/DiseaseImageComponent";
import DiseaseAreaGalleryComponent from "@/components/analysis/DiseaseAreaGalleryComponent";
import DiseaseAreaCountMapComponent from "@/components/analysis/DiseaseAreaCountMapComponent";

export default {
  name: "DiseaseAnalysisComponent",
  components: {
    DiseaseImageComponent,
    DiseaseAreaGalleryComponent,
    DiseaseAreaCountMapComponent,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          cropCode: "",
          engine: {
            visible: false,
            versionList: [],
          },
        };
      },
    },
  },
  data() {
    return {
      areaText: "전국",
      component: {
        disease: {
          cropCode: null,
        },
        area: {
          cropCode: "0",
          callback: null,
        },
        gallery: {
          searchColumns: null,
        },
      },
    };
  },
  watch: {
    "properties.cropCode"(cropCode) {
      this.changeCropCode(cropCode);
    },
    "component.area.callback"(event) {
      if (event != null) {
        //console.log("val : ", val);
        this.component.gallery.searchColumns = {
          sidoCode: event.sidoCode,
          sggCode: event.sggCode,
          cropCode: event.cropCode,
          status: "DISEASE",
        };
        // 지역 텍스트 추가
        this.areaText = `${event.sidoName} ${event.sggName}`;
      }
    },
  },
  methods: {
    async changeCropCode(cropCode) {
      //console.log("engine : ", this.properties.engine);
      this.component.disease.cropCode = cropCode;
      this.component.disease.engine = this.properties.engine;

      this.component.area.cropCode = cropCode;
      this.component.gallery.searchColumns = {
        cropCode: this.component.area.cropCode,
        status: "DISEASE",
      };
      this.areaText = "전국";
    },
  },
};
</script>
